import { X, Plus } from "lucide-react";
import { useState } from "react";

interface FormStep3Props {
  data: {
    etiquetas: string[];
    notas: string;
  };
  onChange: (data: Partial<FormStep3Props["data"]>) => void;
  errors: Record<string, string>;
}

export function LicitacionFormStep3({ data, onChange, errors }: FormStep3Props) {
  const [tagInput, setTagInput] = useState("");

  const addTag = () => {
    const tag = tagInput.trim();
    if (tag && !data.etiquetas.includes(tag)) {
      onChange({ etiquetas: [...data.etiquetas, tag] });
    }
    setTagInput("");
  };

  const removeTag = (tag: string) => {
    onChange({ etiquetas: data.etiquetas.filter((t) => t !== tag) });
  };

  const handleTagKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Etiquetas</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={tagInput}
            onChange={(e) => setTagInput(e.target.value)}
            onKeyDown={handleTagKeyDown}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Añadir etiqueta y pulsar Enter"
          />
          <button
            type="button"
            onClick={addTag}
            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
        {(data.etiquetas ?? []).length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {(data.etiquetas ?? []).map((tag) => (
              <span key={tag} className="inline-flex items-center gap-1 px-2.5 py-1 bg-blue-50 text-blue-700 text-sm rounded-full">
                {tag}
                <button type="button" onClick={() => removeTag(tag)} className="text-blue-400 hover:text-blue-600">
                  <X className="w-3 h-3" />
                </button>
              </span>
            ))}
          </div>
        )}
        {errors.etiquetas && <p className="text-sm text-red-500 mt-1">{errors.etiquetas}</p>}
      </div>

      <div>
        <label htmlFor="notas" className="block text-sm font-medium text-gray-700 mb-1">
          Notas internas
        </label>
        <textarea
          id="notas"
          rows={5}
          value={data.notas}
          onChange={(e) => onChange({ notas: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          placeholder="Notas internas sobre esta licitación (no se comparten externamente)"
        />
      </div>
    </div>
  );
}
